export default __webpack_public_path__ + "static/media/usa-1177272.fce8c241.png";